// extracted by mini-css-extract-plugin
export var about_interviewSec = "style-module--about_interviewSec--c26cb";
export var about_interview_box = "style-module--about_interview_box--132b8";
export var about_interview_company = "style-module--about_interview_company--e5ece";
export var about_interview_img = "style-module--about_interview_img--01116";
export var about_interview_name = "style-module--about_interview_name--80a07";
export var about_interview_txt = "style-module--about_interview_txt--62bac";
export var culture_box = "style-module--culture_box--07323";
export var culture_content_box = "style-module--culture_content_box--bb232";
export var culture_content_img = "style-module--culture_content_img--8b249";
export var culture_content_txt = "style-module--culture_content_txt--e4446";
export var culture_content_wrap = "style-module--culture_content_wrap--da155";
export var culture_contentsec = "style-module--culture_contentsec--9d8f9";
export var culture_img = "style-module--culture_img--71c8b";
export var culture_txt = "style-module--culture_txt--53e58";
export var culturesec = "style-module--culturesec--ca56f";
export var growthSec = "style-module--growthSec--fac64";
export var growth_box = "style-module--growth_box--9f682";
export var growth_img = "style-module--growth_img--a365d";
export var growth_txt = "style-module--growth_txt--09bd6";
export var heading = "style-module--heading--19b58";
export var logo = "style-module--logo--21049";
export var motto_box = "style-module--motto_box--26806";
export var mottosec = "style-module--mottosec--1b0ae";
export var slide = "style-module--slide--78a8f";
export var slideAnimation = "style-module--slideAnimation--cfee2";
export var slider = "style-module--slider--d6fcf";
export var topSec = "style-module--topSec--e0d2f";
export var topVisual = "style-module--topVisual--70fcd";
export var top_business_box = "style-module--top_business_box--6ef2b";
export var top_business_img = "style-module--top_business_img--bef59";
export var top_business_txt = "style-module--top_business_txt--53fbd";
export var top_businesssec = "style-module--top_businesssec--beb32";
export var top_recruit_box = "style-module--top_recruit_box--d9d48";
export var top_recruit_img = "style-module--top_recruit_img--463b5";
export var top_recruit_txt = "style-module--top_recruit_txt--79ad9";
export var top_recruitsec = "style-module--top_recruitsec--ba538";
export var top_vision_box = "style-module--top_vision_box--c3fe6";
export var top_vision_img = "style-module--top_vision_img--ce476";
export var top_vision_txt = "style-module--top_vision_txt--228ca";
export var top_visual_media_outer = "style-module--top_visual_media_outer--9a6e9";
export var trinity_img = "style-module--trinity_img--f2889";
export var trinitysec = "style-module--trinitysec--1f1a2";